import { ZooplaLogo } from '@zoopla/assets';
import { ButtonLink } from '@zoopla-eng/zds-components/button';
import {
    containerStyle,
    linkListStyle,
    linksContainerStyle,
    logoBoxStyle,
    logoContainerStyle,
    menuContainerRealtimeStyle,
    navStyle,
    skipToContentStyle,
    supportTrtlsText
} from './Header.styles.css';
import { Link } from '@zoopla-eng/zds-components/link';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';

export default function RealtimeHeader() {
    return (
        <div className={containerStyle}>
            <div className={skipToContentStyle}>
                <ButtonLink href="#main-content" category="primary">
                    Skip to main content
                </ButtonLink>
            </div>
            <nav className={navStyle} aria-label="main" data-testid={`header`}>
                <div className={logoContainerStyle}>
                    <div className={logoBoxStyle}>
                        <a
                            href="/"
                            aria-label="Zoopla's Homepage"
                            data-testid="zoopla-logo"
                        >
                            <ZooplaLogo />
                        </a>
                    </div>
                </div>
                <div className={menuContainerRealtimeStyle}>
                    <div className={linksContainerStyle}>
                        <ul className={`${linkListStyle} ${fontGroups.ladle}`}>
                            <li key="name" data-testid={`header-menu0`}>
                                <span className={supportTrtlsText}>
                                    The Realtime Listings Service Support:
                                </span>
                            </li>
                            <li
                                key="/realtime-documentation/"
                                data-testid={`header-menu1`}
                            >
                                <Link
                                    href="/realtime-documentation/"
                                    muted
                                    disableVisited
                                >
                                    Documentation
                                </Link>
                            </li>
                            <li
                                key="/realtime-documentation/examples/"
                                data-testid={`header-menu2`}
                            >
                                <Link
                                    href="/realtime-documentation/examples/"
                                    muted
                                    disableVisited
                                >
                                    Examples
                                </Link>
                            </li>
                            <li
                                key="/realtime-documentation/schemas/"
                                data-testid={`header-menu3`}
                            >
                                <Link
                                    href="/realtime-documentation/schemas/"
                                    muted
                                    disableVisited
                                >
                                    Schemas
                                </Link>
                            </li>
                            <li
                                key="/realtime-listing/certificates/signing_requests/"
                                data-testid={`header-menu3`}
                            >
                                <Link
                                    href="/realtime-listings/certificates/signing_requests/"
                                    muted
                                    disableVisited
                                >
                                    Certificates
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
}
